import React, { memo } from 'react';

const RemoteSupportUsersAdvancedSearch: React.FC = () => {
  return <></>;
};

export default memo(RemoteSupportUsersAdvancedSearch);
